import React from 'react'
import { Link } from 'react-router-dom';

function Futuraisland() {
    const images = [
        {
          src: "images/daisypre.jpg",
          title: "Modern Design",
          description: "Available in 91 or 100 cm wide and 120 or 135 cm high models.",
        },
        {
          src: "images/daisypre1.jpg",
          title: "Refrigerated Storage",
          description: "Models with refrigerated understorage and independent temperature control for quick product replenishment.",
        },
        {
          src: "images/daisypre2.jpg",
          title: "Easy Access",
          description: "Front glass with gas strut for easy access and cleaning of the display unit.",
        },
      ];
    return (
        <div className=' font-thin'>
              <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">
    
    {/* ✅ Breadcrumb Navigation */}
    <div className="flex justify-start text-sm md:text-base">
           <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
           <Link to="/islands" className="block py-1 pl-4 hover:underline mt-6">Islands -</Link>
           <span className="block py-1 pl-4 mt-6">FUTURO ISLAND</span>
    
         </div>
         {/* ✅ Product Image on Top */}
         <div className="flex justify-center mb-6">
           <img src="/images/futuroisl1.jpg" alt="Vista" className="max-w-full h-auto object-contain" />
         </div>
    
         {/* ✅ Product Title & Description */}
         <div className="text-center mb-6">
           <h1 className="text-3xl md:text-4xl uppercase mb-8">FUTURO ISLAND</h1>
           <p className="text-xl lg:text-2xl font-thin max-w-sm mx-auto text-gray-500">Bi-temperature display for packed, refrigerated and frozen foods</p>
           <p className="text-xl lg:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">The FUTURO ISLAND is a plug-in display  in which, through a simple button, the operator chooses the temperature of his equipment. Chilled or conservation of frozen products, for packed products such as: meat, fish, charcuterie, desserts and meals. Once it has got casters it is easily positioned wherever suitable in your store.</p>
         </div>
    
         {/* ✅ Models & Model Values */}
    <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>
    
    <div className="grid grid-cols-1 gap-4 text-center mb-6">

       <p className="text-xl lg:text-2xl text-gray-500 opacity-90">Packaged Products <span className='text-fuchsia-950'>-18… -15 °C </span> (3L1)<span className=' text-blue-400'>  /<span className='text-blue-400'>-1… +5 °C</span></span> (3M1)</p>

    </div>

         {/* ✅ Refrigeration */}
         <div>
           <h2 className="text-3xl font-thin text-center mt-10 text-gray-500 ">Refrigeration</h2>
         
           <p className="text-xl lg:text-2xl text-lime-500 text-center mt-6">R290</p>

         </div>

 {/* case 3 */}
 <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
                  {/* ✅ Image Wrapper */}
  <div className="w-full md:w-1/2">
                 <img src="/images/futoislandscase.jpg" className="max-w-full h-auto object-contain" />
               </div>
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl md:text-4xl">Your merchandiser, always ready to use!</p>
    <ul className="list-[square] list-outside text-gray-500">
  {[
    "Fan assisted cooling with positive or negative temperature, allowing the same exhibitor to be used to expose different products.",
    "Plug-in solution, just plug it into the socket.",
    "Sliding glass covers for greater energy efficiency, up to 50% energy savings.",
    "Set of casters for easy in-store movement.",
    "Easy to remove and to sanitize internal components.",
    "LED lighting of high brightness and high energy efficiency."
  ].map((item, index) => (
    <li key={index} className="md:text-xl font-thin opacity-90 mt-6">
      {item}
    </li>
  ))}
</ul>


</div>

             </div>
     </div>
    
  
        </div>
      )
    }


export default Futuraisland